import { BLANK_TEMPLATE_ID } from '../constants/common';

const isBlankTemplate = (template) => template.slug.endsWith(`-${BLANK_TEMPLATE_ID}`);

export default isBlankTemplate;
